<template>
  <div id="quick-review">
    <div class="title">
      <img :src="require('../assets/imgs/'+ grade +'/title-banner1-type3.png')" alt />
      <div class="title-inner">
        <b-icon class="title-icon" name="review" :color="$util.mainTtleColor(grade)" :size="1.2"></b-icon>
        <p class="title-text" :style="{ color: $util.mainTtleColor(grade)}">Quick Review</p>
      </div>
    </div>
    <div class="video-content">
      <div v-if="videoUrl !== ''&&videoUrl !== null" id="mse" style="border-radius: 10px;"></div>
      <img v-else style="max-width: 100%" src="../assets/imgs/stady.jpg" />
    </div>
  </div>
</template>
<script>
import Player from "xgplayer";
export default {
  name: "QuickReview",
  props: {
    videoUrl: {},
    postImg: {},
    grade: {
      default: 6
    }
  },
  data() {
    return {};
  },
  mounted() {
    let player = new Player({
      id: "mse",
      url: [{ src: this.videoUrl, type: "video/mp4" }],
      videoInit: true,
      fluid: true,
      whitelist: ["iPhone OS 9"],
      poster: this.postImg
    });
  }
};
</script>
<style lang="scss">
#quick-review {
  width: 100%;
  background: #fff;
  > .title {
    width: 100%;
    height: 280px;
    /*font-size: 0;*/
    position: relative;
    > img {
      width: 100%;
      height: 100%;
    }
    > .title-inner {
      position: absolute;
      top: 0;
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      padding-left: 5%;
      font-size: 1.2rem;
      color: #7f4224;
      > .title-icon {
        font-size: inherit;
        margin-right: 50px;
        width: 1.2em;
        height: 1.3em !important;
      }
      > .title-text {
        font-size: inherit;
      }
    }
  }
  .video-content {
    padding: 75px;
  }
  #video-element {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuickReview.vue